import { useAppSelector } from "@/store/hooks";

/**
 * ログイン中の自分自身のアカウントロール(account_role: "member"|"admin"|"owner")を取得する。
 *
 * 出所は /auth/me（company.account_role）で、auth slice に保持済みのものを読む。
 * 以前は従業員詳細API(fetchDetailedEmployee)を再取得していたが、
 * (1) /auth/me が既に返している値の二重取得、(2) 共有スライス state.employees.detailed が
 * 他ページ(EmployeeUpdate等)の編集で上書きされる、という問題があったため
 * slice(=単一の正)参照へ統一した。
 */
export const useOwnAccountRole = (): {
  accountRole: string | null;
  loading: boolean;
} => {
  const accountRole = useAppSelector((state) => state.auth.accountRole);
  const loaded = useAppSelector((state) => state.auth.capabilitiesLoaded);
  return { accountRole, loading: !loaded };
};

export default useOwnAccountRole;
